type HasKeyword = (keyword: string) => boolean;

export const hasKeyword: HasKeyword = (keyword) => keyword.trim() !== "";
